var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcStatusY(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ic_status_y"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.43,87.45,53.65,8.35a4.22,4.22,0,0,0-7.3,0L.57,87.45a4.2,4.2,0,0,0,3.65,6.3H95.78A4.2,4.2,0,0,0,99.43,87.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M54.11,82.66V76.1c0-.52-1.84-.94-4.11-.94s-4.11.42-4.11.94v6.56c0,.52,1.84.94,4.11.94S54.11,83.18,54.11,82.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M50,38.46c-3.07,0-5.56.68-5.56,1.53l2.14,27.37a.14.14,0,0,0,0,.06C46.56,68.27,48.1,69,50,69s3.44-.68,3.44-1.53a.14.14,0,0,0,0-.06L55.56,40C55.56,39.14,53.07,38.46,50,38.46Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStatusY);
export default __webpack_public_path__ + "static/media/ic_status_y.86ef371f.svg";
export { ForwardRef as ReactComponent };